// Smart route resolver for the split marketing/app deployment.
// - On https://uphauslabs.com (marketing) auth routes redirect to https://app.uphauslabs.com
// - On https://app.uphauslabs.com or the preview URL, auth routes stay on the same origin
// - Marketing routes go to https://uphauslabs.com when we're on app.uphauslabs.com

const APP_HOST = "app.uphauslabs.com";
const MARKETING_HOST = "uphauslabs.com";

const APP_ROUTES = new Set([
  "/login", "/signup", "/dashboard", "/admin", "/settings",
  "/teams", "/players", "/games", "/practices", "/coach-ai",
  "/coach-dna", "/journey", "/reflect", "/monthly-report",
  "/legacy", "/goals", "/season", "/game-day",
  "/referrals", "/beta", "/help",
]);

function currentHost() {
  return typeof window !== "undefined" ? window.location.hostname : "";
}

/**
 * Return the correct URL for a route given the current host.
 * For internal SPA navigation we still use react-router <Link>, but when we're
 * on the marketing host and heading to an app route, we produce an absolute
 * URL to the app subdomain so localStorage-scoped auth works.
 */
export function resolveHref(path) {
  if (typeof window === "undefined") return path;
  const host = currentHost();
  const first = "/" + (path.split("/")[1] || "");
  const isAppRoute = APP_ROUTES.has(first) || first === "/dashboard";
  if (host === MARKETING_HOST && isAppRoute) return `https://${APP_HOST}${path}`;
  if (host === APP_HOST && !isAppRoute && path.startsWith("/")) return `https://${MARKETING_HOST}${path}`;
  return path; // preview / dev: stay on same origin
}
